import React, { ReactElement, useContext, useEffect, useState } from 'react'
import { ArtData } from '@/database/art'
import { Context, Tokenomics, UserShare } from '@/components/Context'
import { listing } from '@/utils/mapping'
import { getUserShare } from '@/utils/calculations'
import { shortenAddress } from '@/utils/shortenAddress'
import { copyToClipboard } from '@/utils/extras'
import Image from 'next/image'

const calcTotal = (userShare: UserShare, tokenomics: Tokenomics) => {
    const total = (
        (userShare.votes * tokenomics.votes) / 100 +
        (userShare.creator * tokenomics.creator) / 100 +
        (userShare.airdrop * tokenomics.airdrop) / 100
    ).toFixed(2)
    return total != 'NaN' ? total : '-'
}

const TokenomicsOverview = ({ artData }: { artData: ArtData | undefined }): ReactElement => {
    const { getTokenomics, currentAccount, artDataList } = useContext(Context)

    const [tokenomics, setTokenomics] = useState({} as Tokenomics)
    const [currentUserShare, setCurrentUserShare] = useState({} as UserShare)
    const [showTooltip, setShowTooltip] = useState(false)

    useEffect(() => {
        if (artData) {
            setTokenomics(getTokenomics(artData))
            if (currentAccount) {
                setCurrentUserShare(getUserShare(artData, currentAccount, artDataList))
            }
        }
    }, [artData, currentAccount])

    return (
        <div>
            {artData && (
                <div>
                    <span className="white">
                        After the mint is executed, it will go on auction automatically. Proceeds of this forced auction
                        will be distributed as follows:
                    </span>
                    <p className="gray">
                        Status:&nbsp;
                        <span className="white">{listing(artData)}</span>
                    </p>
                    <p className="gray">
                        DAO Fee:&nbsp;
                        <span className="white">{tokenomics.fee}%</span>
                    </p>
                    <p className="gray">
                        Current Owner:&nbsp;
                        <span className="white">{tokenomics.owner}%</span>
                    </p>
                    <p className="gray">
                        Creator Royalty:&nbsp;
                        <span className="white">{tokenomics.creator}%</span>
                    </p>
                    <p className="gray">
                        Burn:&nbsp;
                        <span className="white">{tokenomics.burn}%</span>
                    </p>
                    <p className="gray">
                        Buy & Burn Token:&nbsp;
                        <span>
                            {tokenomics.burnToken ? (
                                <span>
                                    <Image
                                        src="/hexagon-copy.svg"
                                        alt="arrow"
                                        width={15}
                                        height={15}
                                        style={{
                                            marginLeft: '1px',
                                            cursor: 'pointer',
                                        }}
                                        onClick={() => copyToClipboard(tokenomics.burnToken, setShowTooltip)}
                                    />
                                    &nbsp;
                                    <span className="white">{shortenAddress(tokenomics.burnToken)}</span>
                                    <span
                                        style={{
                                            visibility: showTooltip ? 'visible' : 'hidden',
                                            opacity: showTooltip ? 1 : 0,
                                            transition: 'opacity 0.5s ease-in-out',
                                        }}
                                    >
                                        &nbsp;Copied!
                                    </span>
                                </span>
                            ) : (
                                '-'
                            )}
                        </span>
                    </p>
                    <p className="gray">
                        Airdrop:&nbsp;
                        <span className="white">{tokenomics.airdrop}%</span>
                    </p>
                    <p className="gray">
                        Distributed Votes:&nbsp;
                        <span className="white">{tokenomics.votes}%</span>
                    </p>
                    <p className="gray">
                        Distributed Claims:&nbsp;
                        <span className="white">{tokenomics.claims}%</span>
                    </p>
                    <p className="gray">
                        Treasury:&nbsp;
                        <span className="white">{tokenomics.treasury}%</span>
                    </p>
                    <br />
                    <p className="white">Your royalties share&nbsp;</p>
                    <p className="gray">
                        As Creator:&nbsp;
                        <span className="white">
                            {currentUserShare.creator
                                ? ((currentUserShare.creator * tokenomics.creator) / 100).toFixed(2)
                                : '-'}
                            %
                        </span>
                    </p>
                    <p className="gray">
                        Your Voting:&nbsp;
                        <span className="white">
                            {currentUserShare.votes
                                ? ((currentUserShare.votes * tokenomics.votes) / 100).toFixed(2)
                                : '-'}
                            %
                        </span>
                    </p>
                    <p className="gray">
                        Airdrop:&nbsp;
                        <span className="white">
                            {currentUserShare.airdrop
                                ? ((currentUserShare.airdrop * tokenomics.airdrop) / 100).toFixed(2)
                                : '-'}
                            %
                        </span>
                    </p>
                    <p className="gray">
                        Total:&nbsp;
                        <span className="white">{calcTotal(currentUserShare, tokenomics)}%</span>
                    </p>
                </div>
            )}
        </div>
    )
}

export default TokenomicsOverview
